export default {"itemWrapper":"p4ODc","item":"JCNEQ","icon":"tjetB","primary":"m2HQp","secondary":"_-90UA","tertiary":"xswim","selected":"_0aU8d"};